import BaseModel from './BaseModel'

export default class Product extends BaseModel {
  // ... Product-specific methods or overrides ...
}
